export enum WizardOperation {
    Opinion = "opinion",
    Quiz = "quiz",
}
